import React from "react";
import { ContainerScroll } from "./ui/container-scroll-animation"; 
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const IOSAppPage = () => {
    return (
        <div className="relative">
            
            <motion.div
                className="absolute top-4 right-4 z-50"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
            >
                <Link to="/" className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded-lg transition duration-300 ease-in-out">
                    Home
                </Link>
            </motion.div>

            
            <ContainerScroll
                titleComponent={
                    <>
                        <h1 className="text-4xl font-semibold text-black dark:text-white">
                            Order before the crowd with <br />
                            <span className="text-4xl md:text-[6rem] font-bold mt-1 leading-none">
                                WrappedXpress
                            </span>
                        </h1>
                    </>
                }
            >
                <img
                    src="/menu.jpg"
                    alt="iPad Display"
                    className="mx-auto rounded-2xl object-cover h-full w-full"
                    draggable={false}
                />
            </ContainerScroll>
        </div>
    );
};

export default IOSAppPage;























//legacy code

/*
import React from "react";
import { ContainerScroll } from "./ui/container-scroll-animation";

const IOSAppPage = () => {
    console.log("IOSAppPage is rendering");

    return (
        <div className="flex flex-col overflow-hidden">
            <h1></h1>
            <ContainerScroll
                titleComponent={
                    <>
                        <h1 className="text-4xl font-semibold text-black dark:text-white">
                            Order before the crowd with <br />
                            <span className="text-4xl md:text-[6rem] font-bold mt-1 leading-none">
                                WrappedXpress 
                            </span>
                        </h1>
                    </>
                }
            >
                <img
                    src="/linear.webp"
                    alt="hero"
                    className="mx-auto rounded-2xl object-cover h-full object-left-top"
                    draggable={false}
                    style={{ height: "720px", width: "1400px" }}
                />
            </ContainerScroll>
        </div>
    );
};

export default IOSAppPage;
*/